<template>
  <div>
    <validation-provider v-if="!validacaoExterna" v-slot="{ errors }" :name="name" :rules="rules">
      <v-select
        ref="select"
        v-bind="$attrs"
        :id="name"
        :name="name"
        :color="campoCor"
        :item-color="campoCor"
        :items="items"
        :label="label"
        :menu-props="{ offsetY: true, maxHeight: '265px' }"
        :error="errors.length > 0"
        :error-messages="errors.length ? errors[0] : errorMessages"
        :no-data-text="noDataText"
        :item-value="itemValue"
        :item-text="itemText"
        dense
        outlined
        :multiple="multiple"
        :chips="chips"
        :disabled="disabled"
        v-model="selecionado"
        @change="enviar"
        class="estilo-chips"
      />
    </validation-provider>
    <v-select
      v-else
      ref="select"
      v-bind="$attrs"
      :id="name"
      :name="name"
      :color="campoCor"
      :item-color="campoCor"
      :items="items"
      :label="label"
      :menu-props="{ offsetY: true, maxHeight: '265px' }"
      :error="hasError"
      :error-messages="errorMessages"
      :no-data-text="noDataText"
      :item-value="itemValue"
      :item-text="itemText"
      dense
      outlined
      :multiple="multiple"
      :chips="chips"
      :disabled="disabled"
      v-model="selecionado"
      @change="enviar"
      class="estilo-chips"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'soi-select',
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: [String, Object, Array],
      default: () => '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [Array, String],
      default: () => [],
    },
    noDataText: {
      type: String,
      default: 'Nenhum item encontrado',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selecionado: this.value,
    };
  },

  computed: {
    validacaoExterna() {
      return this.errorMessages && this.errorMessages.length > 0;
    },
    hasError() {
      return this.error || (this.errorMessages && this.errorMessages.length > 0);
    },
    campoCor() {
      const primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--especialidade-primary')
        .trim();
      return primaryColor || 'primary';
    },
    itemValue() {
      if (this.$attrs['item-value']) {
        return this.$attrs['item-value'];
      }
      if (this.items && this.items.length > 0 && typeof this.items[0] === 'object' && this.items[0] !== null && 'value' in this.items[0]) {
        return 'value';
      }
      return undefined;
    },
    itemText() {
      if (this.$attrs['item-text']) {
        return this.$attrs['item-text'];
      }
      if (this.items && this.items.length > 0 && typeof this.items[0] === 'object' && this.items[0] !== null && 'text' in this.items[0]) {
        return 'text';
      }
      return undefined;
    },
  },

  watch: {
    value(val) {
      this.selecionado = val;
    },
  },

  methods: {
    enviar(): void {
      this.$emit('input', this.selecionado);
      this.$emit('change', this.selecionado);
    },
  },
});
</script>

<style scoped>
.estilo-chips>>>.v-chip {
  background-color: var(--especialidade-primary, #4CAF50) !important;
  color: white !important;
  font-weight: 500;
  height: 24px !important;
}
</style>
